import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class GetAdReservationStatusRequest extends ValueObject {
  /**
   * @param {String} value
   **/

  #value

  static checkValidData = value => value !== null && value !== undefined && value !== ''

  static validate({value}) {
    const isAdIdValid = GetAdReservationStatusRequest.checkValidData(value?.adId)
    if (!isAdIdValid) throw InvalidParamsSharedError.create(`Invalid ad id => ${value?.adId}`)
  }

  static create({value}) {
    GetAdReservationStatusRequest.validate({value})
    return new GetAdReservationStatusRequest({value})
  }

  constructor({value}) {
    super()
    this.#value = value
  }

  get value() {
    return this.#value
  }

  toJSON() {
    return {value: this.#value}
  }
}
